import { i as h, B as f, e as g, b, x as p, n as c, r as v } from "./abstract-base-CzLmw6_x.js";
import { B as u } from "./beacon-primitive-ChVMWFlW.js";
import { p as y } from "./lifecycle-decorators-CUsT9aHq.js";
import { b as m } from "./query-assigned-K46zQIzj.js";
const x = h`:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer])>:is(a,[beacon-tag-name=beacon-navigation-button]){display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}`, N = h`:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));inline-size:100%}[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}::slotted([slot=title]){color:var(--beacon-system-color-text-title, var(--heritage-navigation-expanded-title-color, var(--beacon-color-text-default-on-light)));font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-300, var(--beacon-headline-font-size-200)/var(--beacon-headline-font-line-height-module-200) var(--beacon-font-family-default))}::slotted([slot=description]){font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-system-color-text-standard, var(--heritage-navigation-expanded-text-color, var(--beacon-color-text-default-on-light)))}.title-area{padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap, var(--beacon-unit-atomic))}.slot-container{display:grid;gap:var(--beacon-reference-space-2, var(--beacon-unit-subatomic))}@media (width >= 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7, 1.5rem)}}`;
var C = Object.defineProperty, S = Object.getOwnPropertyDescriptor, n = (d, e, t, i) => {
  for (var o = i > 1 ? void 0 : i ? S(e, t) : e, s = d.length - 1, l; s >= 0; s--)
    (l = d[s]) && (o = (i ? l(e, t, o) : l(o)) || o);
  return i && o && C(e, t, o), o;
};
const a = class r extends u(f) {
  constructor() {
    super(...arguments), this.level = 1, this.splitColumns = "true", this.hasNestedExpandedNavigations = !1, this.handleCurrentLink = () => {
      this.currentLink && g(this, b.HAS_CURRENT_LINK, !!this.onBeaconCurrentLink && this.onBeaconCurrentLink());
    };
  }
  static get styles() {
    return [super.styles, N];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, x];
  }
  /** Anchor link representing the current page. */
  get currentLink() {
    return this.querySelector('a[aria-current="page"]');
  }
  get hasValidNestedItems() {
    return this.links.filter(
      (e) => (e instanceof r || e instanceof HTMLAnchorElement) && !(e instanceof HTMLStyleElement)
    );
  }
  postrenderHandleCurrentLink() {
    this.handleCurrentLink();
  }
  /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  setLevel() {
    this.level = 1 + (this.parentElement instanceof r ? this.parentElement.level : 0);
  }
  /** Updates based on this component having nested expanded navigations. */
  setNestedState() {
    this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = !0 : this.hasNestedExpandedNavigations = !1;
  }
  /** Calculate a number of CSS columns based on how many links are to be shown. */
  calculateCSSColumns(e) {
    let t = "";
    return e < 6 ? t = "1" : e < 11 ? t = "2" : e < 22 ? t = "3" : t = "4", t;
  }
  /** Calculate the grid template based on how many sections are shown. */
  calculateGridColumnTemplate(e) {
    let t = "";
    return e === 1 ? t = "1fr" : e === 2 ? t = "1fr 1fr" : e === 3 ? t = "1fr 1fr 1fr" : e >= 4 && (t = "1fr 1fr 1fr 1fr"), t;
  }
  setColumnsCSSProperty(e) {
    this.style.setProperty("--expanded-nav-grid-template", e);
  }
  setNestedGridTemplates(e) {
    const t = this.calculateCSSColumns(e);
    this.setColumnsCSSProperty(t);
  }
  setLevel1GridTemplate(e) {
    const t = this.calculateGridColumnTemplate(e);
    this.setColumnsCSSProperty(t);
  }
  setLevel2GridTemplate(e) {
    this.setNestedGridTemplates(e);
  }
  setGridTemplates() {
    let e = this.links.length;
    this.splitColumns === "false" && (e = 1), this.level === 1 ? this.setLevel1GridTemplate(e) : this.level === 2 ? this.setLevel2GridTemplate(e) : this.level === 3 && this.setNestedGridTemplates(e);
  }
  handleTitleSlotchange() {
    var e;
    this.titleSlotVal = (e = this.titleNodes) != null && e.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
  }
  handleDefaultSlotchange() {
    this.setNestedState(), this.setLevel(), this.setGridTemplates();
  }
  renderExpanded() {
    return p`
      <section class="header-zone">
        <div class="title-area">
          <div class="title-container">
            <slot name="title" part="title" @slotchange=${this.handleTitleSlotchange}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <slot @slotchange=${this.handleDefaultSlotchange}></slot>
      </section>
    `;
  }
  render() {
    return p`<div class="level-${this.level}">${this.renderExpanded()}</div> `;
  }
};
n([
  c({ reflect: !0 })
], a.prototype, "level", 2);
n([
  c({ attribute: "split-columns", reflect: !0 })
], a.prototype, "splitColumns", 2);
n([
  c({ type: Function })
], a.prototype, "onBeaconCurrentLink", 2);
n([
  v()
], a.prototype, "titleSlotVal", 2);
n([
  v()
], a.prototype, "hasNestedExpandedNavigations", 2);
n([
  m({ slot: "", flatten: !0 })
], a.prototype, "links", 2);
n([
  m({ slot: "title", flatten: !0 })
], a.prototype, "titleNodes", 2);
n([
  y
], a.prototype, "postrenderHandleCurrentLink", 1);
let k = a;
const G = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button",
  maxLevel: 4
};
export {
  k as B,
  G as C
};
